import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

export class MissingTranslationHandlerDIAN implements MissingTranslationHandler {

    handle(params: MissingTranslationHandlerParams) {
      console.log('Traducción no encontrada, verifique los archivos de idiomas en la siguiente ruta del proyecto assets/i18n', params);
      return 'Por favor verifique que el objeto que esta tratando de acceder se encuentre para el idioma que esta intentando ver';
    }

}


// WEBPACK FOOTER //
// D:/Desarrollo/workspace_160v2/Aplicacion/test/FormularioIngreso160/src/app/configuracion/missing-translation-handler-dian.ts